import {gql, useQuery, type QueryHookOptions} from '@apollo/client'

const DASHBOARD_COUNTS = gql`
  query dashboardCounts {
    box {
      dashboardCounts {
        activeBoxes
        uniqueProductIds
        __typename
      }
      __typename
    }
  }
`

type Data = {
  box: {
    dashboardCounts: {
      activeBoxes: number
      uniqueProductIds: number
      __typename?: 'BoxDashboardCounts'
    }
    __typename?: 'BoxSearchRoot'
  }
}

export function useDashboardCounts(options?: QueryHookOptions<Data>) {
  const {data, ...rest} = useQuery<Data>(DASHBOARD_COUNTS, {
    fetchPolicy: 'cache-first',
    ...options,
  })
  return {
    data: {
      activeBoxes: data?.box?.dashboardCounts.activeBoxes ?? 0,
      uniqueProductIds: data?.box?.dashboardCounts.uniqueProductIds ?? 0,
    },
    ...rest,
  }
}
